import { StringValue } from "google-protobuf/google/protobuf/wrappers_pb";
import { ExtraCategorization as ExtraCategorizationProto } from "../../../../gen/witbooking/backoffice/extra/v1/extra_api_pb";
import { ExtraCategorizationVO } from "../../domain/valueObjects/ExtraCategorizationVO";
import { VehicleType } from "../../domain/VehicleType";
import { ExtraCategoryMapper } from "./ExtraCategoryMapper";

export class ExtraCategorizationMapper {
  /** An absent `categorization` reads as *No category*. */
  static toDomain(proto: ExtraCategorizationProto.AsObject | undefined): ExtraCategorizationVO {
    if (!proto) {
      return ExtraCategorizationVO.none();
    }
    return ExtraCategorizationVO.of({
      category: ExtraCategoryMapper.toDomain(proto.category),
      vehicleType: VehicleType.tryOf(proto.vehicleType?.value),
      requestLicensePlate: proto.requestLicensePlate,
    });
  }

  /** `vehicle_type` is left unset when there is no vehicle type. */
  static toProto(categorization: ExtraCategorizationVO): ExtraCategorizationProto {
    const proto = new ExtraCategorizationProto();
    proto.setCategory(ExtraCategoryMapper.toProto(categorization.category));
    proto.setRequestLicensePlate(categorization.requestLicensePlate);
    if (categorization.vehicleType) {
      const vehicleType = new StringValue();
      vehicleType.setValue(categorization.vehicleType.code);
      proto.setVehicleType(vehicleType);
    }
    return proto;
  }
}
